import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);

/**
 * By default, background is aligned to bottom-right
 * When needed, add new prop align with oneOf(['bottomRight', 'topLeft'..., etc])
 */
export var CardImage = function CardImage(_ref) {
  var src = _ref.src,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cn('component', className),
    src: src,
    "data-t-id": "cards-CardImage"
  });
};
CardImage.propTypes = process.env.NODE_ENV !== "production" ? {
  src: PropTypes.string,
  className: PropTypes.string
} : {};